import React from 'react'
import styled from 'styled-components'

const List = styled.ul`
  display: flex;
  flex-flow: row wrap;
  justify-content: left;
  margin: 0 auto;
`

const CardList = props => {
  return <List>{props.children}</List>
}

export default CardList
